import { getFileExtension } from "../utils/file";
import Itemcard from "./Itemcard";
import service from "../utils/request";
import message from "../utils/message";

const FileList = ({ view, fileList, setFileList, extensions, handleItemClick, openFolder, spaceInfo, getFileList, setPath, setIsPropertiesModalVisible, setCurrentItem, selectedItems, setSelectedItems }) => {

    async function handleOpen(item) {
        const { item_id, item_name, is_folder, item_type } = item;
        if (is_folder) {
            openFolder({ item_id, item_name });
            return;
        }

        const extension = (item_type ? item_type.replace(/^\./, '') : getFileExtension(item_name)).toLowerCase();

        if (extensions.includes(extension)) {
            try {
                const res = await service.get("/filer/edit/" + item_id);
                window.open(`${res.editor}?WOPISrc=${encodeURIComponent(`${res.wopisrc}/${item_id}?access_token=${res.access}`)}`);
            } catch (error) {
                message("error", error.message);
            }
        } else {
            window.open(`/filer/open/${item_id}`);
        }

    }

    return fileList?.map((card) => (
        <Itemcard
            key={card.item_id}
            item={card}
            handleItemClick={handleItemClick}
            spaceInfo={spaceInfo}
            handleOpen={handleOpen}
            getFileList={getFileList}
            setFileList={setFileList}
            openFolder={openFolder}
            setPath={setPath}
            setIsPropertiesModalVisible={setIsPropertiesModalVisible}
            setCurrentItem={setCurrentItem}
            view={view}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
        />
    ));
}

export default FileList;
